import { WhatsAppButton, CallButton } from "@/components/CtaButtons";
import { Reveal, RiseHeading } from "@/components/motion";
import { BRAND } from "@/lib/data";

const FinalCTA = () => (
  <section data-testid="final-cta" className="bg-ink text-offwhite">
    <div className="mx-auto grid max-w-[1400px] gap-10 px-5 py-24 md:grid-cols-12 md:gap-16 md:px-8 md:py-32">
      <div className="md:col-span-7">
        <span className="eyebrow text-white/50 rule">Let's build together</span>
        <RiseHeading className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight md:text-6xl">
          Planning a Glass or <span className="italic text-gold">Aluminium</span> Project?
        </RiseHeading>
        <Reveal delay={0.15}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-white/70 md:text-lg">
            Talk to Nagar Glass about your residential or commercial requirement. Share your idea
            and we'll guide you from consultation to installation.
          </p>
        </Reveal>
      </div>

      <div className="flex flex-col justify-center md:col-span-5">
        <Reveal delay={0.25} className="flex flex-col gap-4">
          <a
            href={`https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(BRAND.whatsappMessage)}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-whatsapp"
            className="inline-flex items-center justify-center gap-2.5 rounded-sm bg-offwhite px-8 py-4 text-sm font-semibold uppercase tracking-[0.14em] text-ink transition-colors hover:bg-gold"
          >
            WhatsApp Nagar Glass
          </a>
          <a
            href={`tel:${BRAND.phoneTel}`}
            data-testid="final-cta-call"
            className="inline-flex items-center justify-center gap-2.5 rounded-sm border border-white/30 px-8 py-4 text-sm font-semibold uppercase tracking-[0.14em] text-offwhite transition-colors duration-500 hover:bg-white/10"
          >
            Call {BRAND.phoneDisplay}
          </a>
          <p className="mt-2 text-center text-xs text-white/50">
            Reply within business hours · Ahmedabad
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);

export default FinalCTA;
